import MotionSection from "../common/MotionSection";
import ActionLink from "../common/ActionLink";
import { aboutPageData } from "../../data/aboutData";

function AboutFinalCta() {
  const { cta } = aboutPageData;

  return (
    <MotionSection className="pb-20 pt-8 md:pb-24 md:pt-12">
      <div className="mx-auto w-full max-w-7xl px-6">
        <div className="relative overflow-hidden rounded-[2rem] bg-gradient-to-r from-midnight-navy via-[#15327A] to-royal-blue px-6 py-12 text-center md:px-10 md:py-16">
          <div className="absolute -left-14 bottom-0 h-56 w-56 rounded-full bg-white/10 blur-3xl" />
          <div className="absolute -right-20 top-0 h-56 w-56 rounded-full bg-warm-gold/25 blur-3xl" />
          <div className="hero-grid absolute inset-0 opacity-20" />

          <div className="relative mx-auto max-w-3xl">
            <h2 className="text-2xl text-soft-white sm:text-3xl md:text-5xl">{cta.title}</h2>
            <p className="mt-5 text-sm leading-relaxed text-sky-glow/85 sm:text-base md:text-lg">{cta.subtitle}</p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <ActionLink variant="ctaPrimary" to={cta.primary.to} label={cta.primary.label} />
              <ActionLink variant="ctaSecondary" to={cta.secondary.to} label={cta.secondary.label} showArrow={false} />
            </div>
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default AboutFinalCta;
